<template>
    <TCinemaSchedule />
</template>

<script>
import TCinemaSchedule from '../../../templates/terminal/t-video-shop';

import {
    fetchShowsByCinemaId,
    fetchMoviesByCinemaId
} from '../../../../utils/services/cinemas-service';
import {
    START_SCREEN,
    TERMINAL_MOVIES,
    TERMINAL_MOVIE_DETAILS
} from '@/utils/constants/pages';
import { GO_BACK_VIEW } from "@/utils/constants/bus-events-constants";
import { mapActions, mapState } from 'vuex';

export default {
    name: 'PVideoShop',
    components: {
        TCinemaSchedule
    },
    data() {
        return {
            cinemaId: this.$route.query.cinemaId,
            objectId: this.$route.query.objectId,
            cinemaProvider: this.$route.query.cinemaProvider
        }
    },
    computed: {
        ...mapState({
            moviesListTimeout: 'moviesListTimeout'
        })
    },
    activated() {
        this.fetchMoviesList();
        // this.getShowsData();
    },
    mounted() {
        this.initListeners();
        this.fetchMoviesList();
    },
    beforeDestroy() {
        this.removeListeners();
    },
    methods: {
        ...mapActions(['getMoviesList']),
        async getShowsData() {
            try {
                const resp = await fetchShowsByCinemaId(this.cinemaId);
                this.$store.commit('setShowsData', resp);
            } catch (error) {
                console.warn(error);
            }
        },
        initListeners() {
            this.$bus.$on(`${GO_BACK_VIEW}-${TERMINAL_MOVIES}`, this.goStartView);
            this.$bus.$on(`${GO_BACK_VIEW}-${TERMINAL_MOVIE_DETAILS}`, this.goVideoGridView);
        },
        removeListeners() {
            this.$bus.$off(`${GO_BACK_VIEW}-${TERMINAL_MOVIES}`, this.goStartView);
            this.$bus.$off(`${GO_BACK_VIEW}-${TERMINAL_MOVIE_DETAILS}`, this.goVideoGridView);
        },
        goStartView() {
            this.$router.push({ name: START_SCREEN });
        },
        goVideoGridView() {
            const params = {
                name: TERMINAL_MOVIES,
                query: {
                    cinemaId: this.cinemaId,
                    objectId: this.objectId,
                    cinemaProvider: this.cinemaProvider
                }
            };

            this.$router.push(params).catch(()=>{});
        },
        isOnline(){
            return window.navigator.onLine;
        },
        fetchMoviesList() {
            const {cinemaId, cinemaProvider} = this
            if(cinemaId && cinemaProvider) this.getMoviesList({cinemaId, cinemaProvider});
        }
    }
}
</script>
